import styles from './noData.module.scss';

export const NoData = () => (
  <div className={styles.noData}>No Procedures found</div>
);
